import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_EMAIL_KEY = "ddf_admin_email";
const ADMIN_PASS_KEY = "ddf_admin_pass";

// Admin credentials are kept in sessionStorage (cleared on tab close) instead of
// localStorage to reduce XSS exposure surface. A future hardening pass should
// move them to an httpOnly cookie-backed session, but that requires a backend
// session endpoint.
export function getAdminCreds() {
  const email = sessionStorage.getItem(ADMIN_EMAIL_KEY);
  const password = sessionStorage.getItem(ADMIN_PASS_KEY);
  if (email && password) return { email, password };
  return null;
}

export function setAdminCreds(email, password) {
  sessionStorage.setItem(ADMIN_EMAIL_KEY, email);
  sessionStorage.setItem(ADMIN_PASS_KEY, password);
}

export function clearAdminCreds() {
  sessionStorage.removeItem(ADMIN_EMAIL_KEY);
  sessionStorage.removeItem(ADMIN_PASS_KEY);
}

export function adminHeaders() {
  const c = getAdminCreds();
  if (!c) return {};
  return {
    "X-Admin-Email": c.email,
    "X-Admin-Password": c.password,
  };
}

// Resolve any media URL to a full URL (handles relative /api/assets paths)
export function resolveMediaUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const api = axios.create({ baseURL: API });

export async function login(email, password) {
  const res = await axios.post(`${API}/admin/login`, { email, password });
  return res.data;
}

export async function fetchConfig() {
  const res = await axios.get(`${API}/config`);
  return res.data;
}

export async function saveConfig(config) {
  const res = await axios.put(`${API}/admin/config`, config, { headers: adminHeaders() });
  return res.data;
}

export async function resetConfigSection(section) {
  const res = await axios.post(`${API}/admin/config/reset`, { section }, { headers: adminHeaders() });
  return res.data;
}

export async function uploadAsset(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await axios.post(`${API}/admin/assets`, fd, {
    headers: { ...adminHeaders(), "Content-Type": "multipart/form-data" },
  });
  return res.data; // { id, url, type, mimetype }
}

export async function startHoldingPdf(promos) {
  const res = await axios.post(`${API}/admin/promos/holding-pdf`, { promos }, { headers: adminHeaders() });
  return res.data;
}

// Polls a holding PDF job until it leaves "running" (or ~6 min elapse).
export async function waitHoldingJob(jobId) {
  for (let i = 0; i < 180; i += 1) {
    const res = await axios.get(`${API}/admin/promos/jobs/${jobId}`, { headers: adminHeaders() });
    if (res.data.status !== "running") return res.data;
    await new Promise((r) => setTimeout(r, 2000));
  }
  return { status: "failed", error: "Timed out waiting for the PDF" };
}

export async function downloadHoldingJobFile(job) {
  const res = await axios.get(`${API}/admin/promos/jobs/${job.id}/file`, {
    headers: adminHeaders(),
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = job.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function emailHoldingPromos(recipient, promos) {
  const res = await axios.post(
    `${API}/admin/promos/email-holding`,
    { recipient, promos },
    { headers: adminHeaders() }
  );
  return res.data;
}
